import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import ChannelsPage from "@/pages/ChannelsPage";
import DashboardPage from "@/pages/DashboardPage";
import IncidentsPage from "@/pages/IncidentsPage";
import LoginPage from "@/pages/LoginPage";
import MaintenancePage from "@/pages/MaintenancePage";
import SiteDetailPage from "@/pages/SiteDetailPage";
import SitesPage from "@/pages/SitesPage";
import UsersPage from "@/pages/UsersPage";

function NotFoundPage(): JSX.Element {
  return (
    <div className="text-center">
      <h1 className="text-2xl font-semibold">Сторінку не знайдено</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Перевірте адресу або поверніться на дашборд.
      </p>
    </div>
  );
}

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="sites" element={<SitesPage />} />
        <Route path="sites/:id" element={<SiteDetailPage />} />
        <Route path="channels" element={<ChannelsPage />} />
        <Route path="incidents" element={<IncidentsPage />} />
        <Route path="maintenance" element={<MaintenancePage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
